var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"lg":"12"}},[_c('v-card',{staticClass:"card--shadow"},[_c('list',{attrs:{"supervisionData":_vm.supervisionData,"isUncompleted":true}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }